<template>
  <v-snackbar
    :color="color"
    :bottom="true"
    :top="false"
    :left="false"
    :right="true"
    :timeout="6000"
    v-model="is_visible"
    dark
  >
    <v-icon color="white" class="mr-3">notifications</v-icon>
    <div v-text="message"></div>
    <v-icon color="white" class="mr-3" @click="is_visible = false">highlight_off</v-icon>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    color: {
      type: String,
      required: true,
      validator(value) {
        return ['info', 'success', 'warning', 'error'].indexOf(value) !== -1;
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
    message: String,
  },
  data() {
    return {
      is_visible: false,
    };
  },
  watch: {
    show(visible) {
      if (visible) this.is_visible = true;
    },
    is_visible(visible) {
      if (!visible) {
        this.$emit('update', visible);
      }
    },
  },
};
</script>

<style scoped>
</style>
